











































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component<GlobalCardArt>({})
export default class GlobalCardArt extends Vue {
    @Prop({ default: 'XXXXXXXXXXX' })
    public memberNumber!: string;
}
